import { Link } from "react-router-dom";

export default function Section7() {
    return (
        <div className="w-full Section6 pb-[4%] pt-0 md:pt-[20]">
            <div className="w-full mx-auto section6-container">
                <div className="w-[90%] md:w-[71%] mx-auto text-center pb-[1%]">
                    <h2 className="text-[24px] md:text-[34px] font-bold text-[#151515] leading-[29px] md:leading-[41px] my-[0.67em]">
                        Scale Your Ecommerce Business with Shopify Plus
                    </h2>
                    <p className="leading-[20px] w-full md:w-[100%] text-[#373737] text-base m-auto font-open">
                        From startups to enterprise brands, Mean3 is a trusted Shopify Plus development company delivering measurable results to Texas businesses. We combine strategy, design, and technical expertise to build secure, scalable, and enterprise-ready stores.
                    </p>
                    <br></br>
                    <p className="leading-[20px] w-full md:w-[100%] text-[#373737] text-base m-auto font-open">
                        Ready to expand your ecommerce business? Contact our Shopify Plus experts in Texas to start building a store designed for high-volume sales, automation, and long-term enterprise growth.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10 ">
                        <a
                            href="https://mean3.com/contact-mean3"
                            className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300"
                        >
                            Get a Free Consultation
                        </a>

                        <a
                            href="https://mean3.com/contact-mean3"
                            className="border border-[#DA2128] text-[#DA2128] hover:bg-[#DA2128] hover:text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300"
                        >
                            View Our Work
                        </a>
                    </div>

                </div>


                <div className="w-full flex flex-wrap sxl:flex-nowrap justify-center p-[30px]  md:py-[2%] gap-x-0 min-[1171px]:gap-x-[7%]">
                    <img
                        src="../../../assets/shopifyplus-diners.webp"
                        alt="Website Image One"
                        className="cover inline-block md:w-auto py-[10px] md:py-0 w-[90%]"
                    />
                    <img
                        src="../../../assets/shopifyplus-white.webp"
                        alt="Website Image Two"
                        className="cover inline-block md:w-auto w-[90%] py-[10px] md:py-0"
                    />
                </div>
            </div>
        </div>
    );
}
